import { FC, PropsWithChildren } from "react";
import { styled } from "styled-components";
import { Grid, useResponsiveDisplayMode } from "capitalrx-components-2.0/lib/layout";
import { ContentContainer, ThemedGradient } from "@/premium/themedComponents";

const GridContainer = styled(Grid)`
  padding-top: 24px;
`;

const MobileGridContainer = styled(Grid)`
  padding-top: 24px;

  & > :first-child {
    margin: 0px 16px;
  }
`;

export const PageLayout: FC<PropsWithChildren<{}>> = (props) => {
  const { children } = props;
  const displayMode = useResponsiveDisplayMode();
  const Container = displayMode === "desktop" ? GridContainer : MobileGridContainer;
  return (
    <ContentContainer>
      <ThemedGradient />
      <Container>
        {displayMode === "desktop" && <Grid.Span columns={1} />}
        <Grid.Span columns={displayMode === "desktop" ? 10 : 12}>
          <>{children}</>
        </Grid.Span>
        {displayMode === "desktop" && <Grid.Span columns={1} />}
      </Container>
    </ContentContainer>
  );
};
